import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { SurveyAvailabilityBadge as SurveyAvailabilityBadgeVariant } from '../lib/instrument-info-state'
import { SurveyAvailabilityBadge } from './SurveyAvailabilityBadge'
import {
  surveyEntryHeaderBlockSx,
  surveyEntryObjectiveSx,
  surveyEntryTitleSx,
} from '../styles/surveyEntryStyles'

interface SurveyEntryHeaderProps {
  readonly name: string
  readonly description?: string | null
  readonly availability: SurveyAvailabilityBadgeVariant
}

export function SurveyEntryHeader({
  name,
  description,
  availability,
}: SurveyEntryHeaderProps) {
  const subtitle = description?.trim() ?? ''

  return (
    <Box sx={surveyEntryHeaderBlockSx}>
      <SurveyAvailabilityBadge variant={availability} />
      <Typography component="h1" sx={surveyEntryTitleSx} data-testid="instrument-info-title">
        {name}
      </Typography>
      {subtitle ? (
        <Typography
          component="p"
          sx={surveyEntryObjectiveSx}
          data-testid="instrument-info-description"
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  )
}
